import React from "react";
import { MediaBaseUrl } from "../../actions/api";
import { getCurrentUrl } from "../../utils";
export const PageNotFound = () => {
    return (
        <div className="error_page__" data-template="400">
            <div className="container">
                <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(100vh - 65px)' }}>
                    <div className="error_wrap py-8">
                        <div className="error_img d-flex justify-content-center mb-5 pt-5">
                            <img className="img-fluid" src={`${MediaBaseUrl}error/plug.svg`} width={583} height={136} alt="connection" />
                        </div>
                        <div className="error_img d-flex justify-content-center mb-5 w-50 m-auto">
                            <img className="img-fluid" src={`${MediaBaseUrl}error/oops.svg`} width={291} height={89} alt="oops" />
                        </div>
                        <div className="text-center pb-3">
                            <h2 className="font-weight-bold">We searched everywhere!</h2>
                            <p className="text-muted">This page could not be found.</p>
                        </div>
                        <div className="btn_wrap text-center mb-5">
                            <a href={`${getCurrentUrl()}`} className="btn btn-primary btn-min-w">Back To Home</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};